/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiEmailDtoDkimRecord
 */
export interface WebApiEmailDtoDkimRecord {
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoDkimRecord
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoDkimRecord
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoDkimRecord
     */
    hostName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiEmailDtoDkimRecord
     */
    status?: boolean;
}

/**
 * Check if a given object implements the WebApiEmailDtoDkimRecord interface.
 */
export function instanceOfWebApiEmailDtoDkimRecord(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiEmailDtoDkimRecordFromJSON(json: any): WebApiEmailDtoDkimRecord {
    return WebApiEmailDtoDkimRecordFromJSONTyped(json, false);
}

export function WebApiEmailDtoDkimRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiEmailDtoDkimRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'hostName': !exists(json, 'host_name') ? undefined : json['host_name'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function WebApiEmailDtoDkimRecordToJSON(value?: WebApiEmailDtoDkimRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'value': value.value,
        'host_name': value.hostName,
        'status': value.status,
    };
}

